var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89305 1.0611L8.94035 0.108398L5.16332 3.88543L1.3863 0.108398L0.433594 1.0611L4.21062 4.83813L0.433594 8.61516L1.3863 9.56786L5.16332 5.79083L8.94035 9.56786L9.89305 8.61516L6.11603 4.83813L9.89305 1.0611Z",
    fill: "#FF3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedStatusIcon);
export default __webpack_public_path__ + "static/media/RejectedStatusIcon.54dc88f4e913e126ea69e1aa4e5d18c4.svg";
export { ForwardRef as ReactComponent };